export default {
  validate: "BTN_VALIDATE",
  back: "BTN_BACK",
  blockCode: "LBL_BLOCK_CODE",
  placeholder: "LBL_PLACEHOLDER",
  login: "LBL_LOGIN",
  civ: "LBL_CIVILITY",
  loginPrefix: "LBL_LOGIN_PREFIX",
  firstname: "LBL_FIRSTNAME",
  lastname: "LBL_LASTNAME",
  email: "LBL_EMAILL_ADDRESS",
  mobilePhone: "LBL_MOBILE_PHONE",
  profile: "LBL_PROFILE",
  tenant: "LBL_TENANT",
  owner: "LBL_OWNER",
  password: "LBL_PASSWORD",
  lblMessage: "LBL_MESSAGE",
  lblConfirmButton: "BTN_CONFIRM",
  lblSuccessMessage: "LBL_SUCCESS_MESSAGE"
}



// WEBPACK FOOTER //
// ./src/locales/user/index.ts